import { useMemo } from 'react';
import { gql, useQuery } from '@apollo/client';

const PAGE_OF_TASK_RESOURCE_ROLE_OPTIONS_QUERY = gql`
  query GetPageOfTaskResourceRoleOptions(
    $taskId: String!
    $userUri: String
    $page: Int!
    $pageSize: Int!
    $textSearch: String
  ) {
    task(taskId: $taskId) {
      id
      pageOfTaskResourceRoleOptions(
        userUri: $userUri
        page: $page
        pageSize: $pageSize
        textSearch: $textSearch
      ) {
        roles {
          projectRole {
            id
            displayText
          }
          isAssigned
          isDefault
        }
        hasMore
      }
    }
  }
`;

const usePageOfTaskResourceRoleOptions = ({
  taskUri,
  userUri,
  page,
  pageSize,
  textSearch,
  skip = false
}) => {
  const { data, loading } = useQuery(PAGE_OF_TASK_RESOURCE_ROLE_OPTIONS_QUERY, {
    variables: {
      taskId: taskUri,
      userUri,
      page,
      pageSize,
      textSearch: textSearch || null
    },
    skip: skip || !taskUri,
    fetchPolicy: 'cache-and-network'
  });

  const pageOfTaskResourceRoleOptions =
    data?.task?.pageOfTaskResourceRoleOptions;
  const options = pageOfTaskResourceRoleOptions?.roles;

  const roles = useMemo(
    () =>
      (options ?? []).map(({ projectRole, isAssigned }) => ({
        roleUri: projectRole.id,
        displayText: projectRole.displayText,
        isAssigned
      })),
    [options]
  );

  return {
    roles,
    hasMore: pageOfTaskResourceRoleOptions?.hasMore ?? false,
    loading
  };
};

export default usePageOfTaskResourceRoleOptions;
